import Sheet from '../../shared/ui/Sheet';
import { Card, EmptyState, StatusBadge } from '../../shared/ui';
import { Car, User, MapPin } from 'lucide-react';
import { formatCurrency } from '../../shared/models';
import { deliveryAddressText } from './geo';

// Bottom sheet listing the driver's active deliveries
// (mirrors iOS ActiveDeliveriesView / DriverAcceptedOrderCard).
export default function ActiveDeliveriesSheet({ open, onClose, deliveries, onSelect }) {
  const sorted = [...deliveries].sort(
    (a, b) => (a.acceptedAt?.getTime?.() || 0) - (b.acceptedAt?.getTime?.() || 0)
  );
  return (
    <Sheet open={open} onClose={onClose} title="Active Deliveries">
      {sorted.length === 0 ? (
        <EmptyState
          icon={Car}
          title="No Active Deliveries"
          subtitle="Accept orders from the Orders tab to start delivering"
        />
      ) : (
        <div className="space-y-3 p-4">
          {sorted.map((o, i) => {
            const num = String(o.orderId || o.id).slice(0, 8);
            // Accept-time driverPayout already includes the tip; the
            // fallback recomputes it for legacy docs missing the field.
            const payout =
              Number(o.driverPayout ?? o.totalEarnings) ||
              (o.deliveryFee || 0) * 0.9 + (o.tipAmount || 0);
            return (
              <Card key={o.id} onClick={() => onSelect(o)} className="space-y-2.5 p-4">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <p className="truncate text-sm font-extrabold text-gray-900">
                      {sorted.length > 1 ? `Order ${i + 1} · ` : ''}#{num}
                    </p>
                    <p className="truncate text-xs text-gray-500">
                      {o.restaurantName || 'Restaurant'}
                    </p>
                  </div>
                  <StatusBadge status={o.status} />
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-700">
                  <User size={14} className="shrink-0 text-gray-400" />
                  <span className="truncate">{o.customerName || 'Customer'}</span>
                  <span className="flex-1" />
                  <span className="block text-xs font-extrabold text-green-600">
                    You Earn: {formatCurrency(payout)}
                  </span>
                </div>
                {deliveryAddressText(o) && (
                  <div className="flex items-start gap-2 text-[11px] text-gray-500">
                    <MapPin size={14} className="mt-0.5 shrink-0 text-gray-400" />
                    <span className="line-clamp-2">{deliveryAddressText(o)}</span>
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      )}
    </Sheet>
  );
}
